import { render } from "./Press.vue?vue&type=template&id=0ec80a1d&scoped=true"
import script from "./Press.vue?vue&type=script&lang=ts"
export * from "./Press.vue?vue&type=script&lang=ts"

import "./Press.vue?vue&type=style&index=0&id=0ec80a1d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0ec80a1d"

export default script